import QuizUnityView from './QuizUnityView'

export default QuizUnityView
